import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 한국어 번역
import ko from './locales/ko.json';
// 영어 번역
import en from './locales/en.json';
// 프랑스어 번역
import fr from './locales/fr.json';

const resources = {
  ko: {
    translation: ko
  },
  en: {
    translation: en
  },
  fr: {
    translation: fr
  }
};

// 지원되는 언어 목록
const supportedLanguages = ['ko', 'en', 'fr'];

// 사용자의 기본 언어를 감지하고 지원되는 언어인지 확인하는 함수
const getDefaultLanguage = () => {
  // localStorage에서 저장된 언어 설정 확인
  const savedLanguage = localStorage.getItem('i18nextLng');
  if (savedLanguage && supportedLanguages.includes(savedLanguage)) {
    return savedLanguage;
  }

  // 브라우저의 기본 언어 감지
  const browserLanguage = navigator.language || navigator.languages?.[0] || 'en';
  const primaryLanguage = browserLanguage.split('-')[0]; // 'ko-KR' -> 'ko'

  // 지원되는 언어인지 확인
  if (supportedLanguages.includes(primaryLanguage)) {
    return primaryLanguage;
  }

  // 지원되지 않는 언어인 경우 영어를 기본값으로 설정
  return 'en';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: getDefaultLanguage(), // 동적으로 기본 언어 설정
    debug: false,
    
    interpolation: {
      escapeValue: false, // React에서는 XSS 방지가 자동으로 처리됨
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupSessionStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
    }
  });

export default i18n; 